import actions from './moduleObjectActions';
import mutations from './moduleObjectMutations';
import getters from './moduleObjectGetters';
import state from './moduleObjectState';

export default {
  namespaced: true,
  mutations,
  actions,
  getters,
  state: () => {
    state;
  },
};
